import { render, staticRenderFns } from "./about-me.vue?vue&type=template&id=74bf01e0&scoped=true&"
import script from "./about-me.vue?vue&type=script&lang=ts&"
export * from "./about-me.vue?vue&type=script&lang=ts&"
import style0 from "./about-me.vue?vue&type=style&index=0&id=74bf01e0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74bf01e0",
  null
  
)

export default component.exports